import request from '@core/services/request';

import { $cache, getSaturnGetRequest, getSettingsData } from '@core/services/api/_api';
import { AxiosResponse } from 'axios';
import { IStateSettings } from '@core/classes/Settings/StateSettings';
import { SaturnExpression } from '@core/classes/SaturnExpressions';
import SaturnExpressionRequest from '@core/classes/Requests/SaturnExpressionRequest';
import StoreClass from '@core/classes/Store/Store';
import StoreFee from '@core/classes/Store/StoreFee';
import { PermissionSetting } from '@core/classes/PermissionSetting';
import SaturnResponse from '@core/classes/Responses/SaturnResponse';
import { EmployeePermissionsType } from '@core/classes/SharedEnums';

export const settingsAPI = {
	getStatusListForType: (statusType: number, settingsModel: any) => request.post(`/Settings/GetStatusListForType?statusType=${statusType}`, settingsModel),
	//gets
	getUsers: (searchBy: any = null, searchText: any = null) => {
		let url = `/Settings/GetEmployees`;
		const params = [];
		if (searchBy) {
			params.push(`searchBy=${searchBy}`);
		}
		if (searchText) {
			params.push(`searchText=${searchText}`);
		}
		if (params.length > 0) {
			url += '?' + params.join('&');
		}
		return request.get(url);
	},
	getSeleniumLatestVersion: () => request.getMs('/MediaServices/GetSeleniumLatestVersion'),
	getSeleniumVersion: () => request.get('/Settings/GetSeleniumVersion'),
	GetEmployeesDropdown: (searchBy: any = null, searchText: any = null) => request.get(`/Settings/GetEmployeesDropdown?searchBy=${searchBy}&searchText=${searchText}`),
	getEmployeeList: () => request.get(`/Settings/GetEmployeesList`),
	getUsersPaged: (pagedRequest: any) => request.post(`/Settings/GetEmployeesPaged`, pagedRequest),
	getUserByCode: (usercode: any) => request.get(`/Settings/GetEmployeeByCode/` + usercode),
	getUserById: (userId: any) => request.get(`/Settings/GetEmployeeById/` + userId),
	getUsersById: (idList: string[]) => request.post(`/Settings/GetEmployeesById`, idList),
	getStores: () => request.get(`/Settings/GetStores`),
	getGlobalSettings: (overridesModel?: any, modelType?: any) => request.post(`/Settings/GetGlobalSettings`, getSaturnGetRequest(null, overridesModel, modelType)),
	getCustomerAppSettings: () => request.get(`/Settings/GetCustomerAppSettings`),
	getPlaidEnvironment: () => request.get(`/Settings/GetPlaidEnvironment`),
	getLogRocketEnvironmentVars: () => request.get(`/Settings/GetLogRocketEnvironmentVars`),
	getStore: (storeCode: string, overridesModel?: any, modelType?: any) =>
		request.post<any, StoreClass>(`/Settings/GetStoresByStoreCode/` + storeCode, getSaturnGetRequest(storeCode, overridesModel, modelType)),
	getStoreBasicInfo: (storeCode: any) => request.get(`/Settings/GetStoreBasicInfo/` + storeCode),
	getStoreMainLogo: (storeCode: any) =>
		request.get(`/Settings/GetStoreMainLogo?storeCode=${storeCode}`, {
			headers: { Accept: 'image/png' },
		}),
	downloadStoreMainLogo: (storeCode: any, fileName: any) => request.downloadPost(`/Settings/DownloadStoreMainLogo?storeCode=${storeCode}`, '', fileName),
	getStoreFile: (storeCode: any, filePath?: any, fileType?: any) =>
		request.get(`/Settings/GetStoreFile?storeCode=${storeCode}&filePath=${filePath}&fileType=${fileType}`, {
			headers: { Accept: 'image/png' },
		}),
	getLenders: () => request.get(`/Settings/GetLenders`),
	getLenderNames: () => request.get(`/Settings/GetLenderNames`),
	getStatusList: () => request.get(`/Settings/GetStatusList`),
	getLenderCodes: () => request.get(`/Settings/GetLenderCodes`),
	getProducts: () => request.get(`/Settings/GetProducts`),
	getStateProducts: (stateCode: any, overridesModel?: any, modelType?: any) =>
		request.post('/Settings/GetStateProducts', getSaturnGetRequest(stateCode, overridesModel, modelType)),
	getStoreDartSettings: (storeCode: any) => request.get(`/Dart/GetMappingSettings/` + storeCode),
	getStoreProductLenderMappings: (storeCode: any) => request.get(`/Settings/GetStoreProductLenderMappings/` + storeCode),
	getStoreFees: (storeCode: string) => request.get<StoreFee[]>(`/Settings/GetStoreFees/` + storeCode),
	getStoreProducts: (storeCode: any) => request.get(`/Settings/GetStoreProducts/` + storeCode),
	getStoreAdditions: (storeCode: any) => request.get(`/Settings/GetStoreAdditions/` + storeCode),
	getStoreRebates: (storeCode: any) => request.get(`/Settings/GetStoreRebates/` + storeCode),
	//getDefaultProductLenderMappings: (storeCode, productType, providerCode) => request.get(`/Settings/GetStoreProductLenderMappings/` + storeCode + `/` + productType + `/` + providerCode),
	getGetReserveProfitCalcs: (refresh?: any, overridesModel?: any) =>
		getSettingsData($cache.lookups.reserveProfitCalcs, '/Settings/GetReserveProfitCalcs', refresh, overridesModel),
	getVehicleTypes: (refresh?: any, overridesModel?: any) => getSettingsData($cache.lookups.vehicleTypes, '/Settings/GetVehicleTypes', refresh, overridesModel),
	getTermSpreads: (refresh?: any, overridesModel?: any) => getSettingsData($cache.lookups.termSpreads, '/Settings/GetTermSpreads', refresh, overridesModel),
	getDeviationReasons: (refresh?: any, overridesModel?: any) =>
		getSettingsData($cache.lookups.deviationReasons, '/Settings/GetDeviationReasons', refresh, overridesModel),
	getSaleTypes: (refresh?: any, overridesModel?: any) => getSettingsData($cache.lookups.saleTypes, '/Settings/GetSaleTypes', refresh, overridesModel),
	getDealTypes: (refresh?: any, overridesModel?: any) => getSettingsData($cache.lookups.dealTypes, '/Settings/GetDealTypes', refresh, overridesModel),
	getAdvertisementTypes: (refresh?: any, overridesModel?: any) =>
		getSettingsData($cache.lookups.advertisementTypes, '/Settings/GetAdvertisementTypes', refresh, overridesModel),
	getAdvertisementSources: (refresh?: any, overridesModel?: any) =>
		getSettingsData($cache.lookups.advertisementSources, '/Settings/GetAdvertisementSources', refresh, overridesModel),
	getProviders: (refresh?: any, overridesModel?: any) => getSettingsData($cache.lookups.providers, '/Settings/GetProviders', refresh, overridesModel),
	getGeneralMappings: (refresh?: any, overridesModel?: any) => getSettingsData($cache.lookups.generalMappings, '/Settings/GetGeneralMappings', refresh, overridesModel),
	getWarrantyExpirationRules: (refresh?: any, overridesModel?: any) =>
		getSettingsData($cache.lookups.warrantyExpirationRules, '/Settings/GetWarrantyExpirationRules', refresh, overridesModel),
	getSurcharges: (refresh?: any, overridesModel?: any) => getSettingsData($cache.lookups.surcharges, '/Settings/GetSurcharges', refresh, overridesModel),
	getCreditBureaus: (refresh?: any, overridesModel?: any) => getSettingsData($cache.lookups.creditBureaus, '/Settings/GetCreditBureaus', refresh, overridesModel),
	getDocumentDataVariables: () => request.get(`/Settings/GetDocumentDataVariables`),
	getDocumentTypes: () => request.get(`/Settings/GetDocumentTypes`),
	getBrands: () => request.get(`/Lookup/GetMakes`),
	getModels: () => request.get(`/Lookup/GetModels`),
	getModelsForMake: (makeId: any) => request.get(`/Lookup/GetModelsForMake/${makeId}`),
	getStylesForModel: (modelId: any) => request.get(`/Lookup/GetStylesForModel/${modelId}`),
	getMakeByStyle: (styleId: any) => request.get(`/Lookup/GetMakeByStyle/${styleId}`),
	getModelByStyle: (styleId: any) => request.get(`/Lookup/GetModelByStyle/${styleId}`),
	// getModelsByBrand: (brandId) => new Promise((resolve) => {
	//     let allModels = $cache.lookups.models;
	//     let filteredModels = allModels.filter(m => m.brandId == brandId);
	//     return resolve({ data: filteredModels });
	// }),
	getLegalTerms: () => request.get(`/Settings/GetLegalTerms`),
	getNotarySettings: () => request.get(`/Settings/GetNotarySettings`),
	updateNotarySettings: (notarySettings: any) => request.post(`/Settings/UpdateNotarySettings`, notarySettings),
	deleteNotarySettings: (id: string) => request.post(`/Settings/DeleteNotarySettings?id=${id}`),
	getLegalTermsByType: (isLatestVersion: any, termsTypes?: any) => request.post(`/Settings/GetLegalTermsByType?isLatestVersion=${isLatestVersion}`, termsTypes),
	getIsSendCustomerHtmlEnabled: () => request.get(`/Settings/GetIsSendCustomerHtmlEnabled`),

	//sets
	setGlobalSettings: (globalSettings: any) => request.post(`/Settings/SetGlobalSettings`, globalSettings),
	upsertStore: (store: StoreClass) => request.post(`/Settings/UpsertStore`, store),
	deleteStore: (id: any) => request.post(`/Settings/DeleteStore?id=${id}`),
	setStores: (stores: any, deleted: any) =>
		request.post(`/Settings/SetStores`, {
			storesToUpdate: stores,
			storesToDelete: deleted,
		}),
	saveStoreFile: (form: any) => request.post(`/Settings/SaveStoreFile`, form),
	setVehicleTypes: (vehicleTypes: any) => request.post(`/Settings/SetVehicleTypes`, vehicleTypes),
	setPositions: (postions: any) => request.post(`/Settings/SetPostions`, postions),
	setTermSpreads: (termSpreads: any) => request.post(`/Settings/SetTermSpreads`, termSpreads),
	setDeviationReasons: (deviationReasons: any) => request.post(`/Settings/SetDeviationReasons`, deviationReasons),
	setSaleTypes: (saleTypes: any) => request.post(`/Settings/SetSaleTypes`, saleTypes),
	setDealTypes: (dealTypes: any) => request.post(`/Settings/SetDealTypes`, dealTypes),
	setAdvertisementTypes: (advertisementTypes: any) => request.post(`/Settings/SetAdvertisementTypes`, advertisementTypes),
	setAdvertisementSources: (advertisementSources: any) => request.post(`/Settings/SetAdvertisementSources`, advertisementSources),
	setLenders: (lenders: any, deleted: any) =>
		request.post(`/Settings/SetLenders`, {
			lendersToUpdate: lenders,
			lendersToDelete: deleted,
		}),
	upsertLender: (lender: any) => request.post(`/Settings/UpsertLender`, lender),
	deleteLender: (id: any) => request.post(`/Settings/DeleteLender?id=${id}`),
	setReserveProfitCalcs: (reserveProfitCalcs: any, deleted: any) =>
		request.post(`/Settings/SetReserveProfitCalcs`, {
			calcsToUpdate: reserveProfitCalcs,
			calcsToDelete: deleted,
		}),
	upsertReserveProfitCalcs: (reserveProfitCalc: any) => request.post(`/Settings/UpsertReserveProfitCalcs`, reserveProfitCalc),
	deleteReserveProfitCalcs: (id: any) => request.post(`/Settings/DeleteReserveProfitCalcs?id=${id}`),
	setProducts: (products: any, deleted: any) =>
		request.post(`/Settings/SetProducts`, {
			productsToUpdate: products,
			productsToDelete: deleted,
		}),
	upsertProduct: (product: any) => request.post(`/Settings/UpsertProduct`, product),
	deleteProduct: (id: any) => request.post(`/Settings/DeleteProduct?id=${id}`),
	setSurcharges: (surcharges: any) => request.post(`/Settings/SetSurcharges`, surcharges),
	upsertSurcharge: (surcharge: any) => request.post(`/Settings/UpsertSurcharge`, surcharge),
	setStatusList: (status: any) => request.post(`/Settings/SetStatusList`, status),
	upsertStatusList: (status: any) => request.post(`/Settings/UpsertStatusList`, status),
	setProviders: (providers: any) => request.post(`/Settings/SetProviders`, providers),
	upsertProvider: (provider: any) => request.post(`/Settings/UpsertProvider`, provider),
	setGeneralMappings: (mappings: any) => request.post(`/Settings/SetGeneralMappings`, mappings),
	upsertGeneralMappings: (mapping: any) => request.post(`/Settings/UpsertGeneralMappings`, mapping),
	deleteGeneralMappings: (mapping: any) => request.post(`/Settings/DeleteGeneralMappings`, mapping),
	setWarrantyExpirationRules: (warrantyExpirationRules: any, deleted: any) =>
		request.post(`/Settings/SetWarrantyExpirationRules`, {
			rulesToUpdate: warrantyExpirationRules,
			rulesToDelete: deleted,
		}),
	upsertWarrantyExpirationRules: (rule: any) => request.post(`/Settings/UpsertWarrantyExpirationRules`, rule),
	deleteWarrantyExpirationRules: (rule: any) => request.post(`/Settings/DeleteWarrantyExpirationRules`, rule),
	upsertDocumentDataVariables: (variables: any) => request.post(`/Settings/UpsertDocumentDataVariables`, variables),
	deleteDocumentDataVariable: (variable: any) => request.post(`/Settings/DeleteDocumentDataVariable`, variable),
	upsertDocumentTypes: (docTypeList: any) => request.post(`/Settings/BulkUpdateDocumentTypes`, docTypeList),
	upsertDocumentType: (docType: any) => request.post(`/Settings/UpsertDocumentType`, docType),
	setLegalTerms: (legalTerm: any) => request.post(`/Settings/SetLegalTerms`, legalTerm),
	upsertCreditBureau: (creditBureau: any) => request.post(`/Settings/UpsertCreditBureau`, creditBureau),
	setELeadSettings: (eLeadSettings: any) => request.post(`/Settings/SetELeadSettings`, eLeadSettings),

	//PEN Settings
	PENSetDealer: (store: any) => request.post(`/PEN/SetDealer`, store),
	PENGetProviders: () => request.post(`/PEN/GetProviders`),
	PENGetProducts: (providerId: any) => request.get(`/PEN/GetProducts/${providerId}`),
	PENGetProvidersAndProducts: (PENDealerId: any) => request.get(`/PEN/GetProvidersAndProducts/${PENDealerId}`),
	PENGetSavedProviders: () => request.get(`/PEN/GetSavedProviders`),
	PENGetSavedProducts: () => request.get(`/PEN/GetSavedProducts`),
	PENSaveProduct: (PENproduct: any) => request.post(`/PEN/SaveProduct`, PENproduct),
	PENRegisterProduct: (dealerId: any, PENproduct: any, providerDealerCode: any, providerProductCode: any) =>
		request.post(`/PEN/RegisterProduct`, {
			dealerId,
			PENproduct,
			providerDealerCode,
			providerProductCode,
		}),
	PENUpdateProduct: (dealerId: any, PENproduct: any) => request.post(`/PEN/UpdateProduct`, { dealerId, PENproduct }),
	PENUpdateProductMappings: (PENproduct: any) => request.post(`/PEN/UpdateProductMappings`, PENproduct),
	PENUnregisterProduct: (dealerId: any, PENproduct: any) => request.post(`/PEN/UnregisterProduct`, { dealerId, PENproduct }),
	//RouteOne Settings
	RouteOneGetCreditAppFields: (store: any) => request.post('/RouteOne/GetCreditAppFields', store),
	//RouteOneTestConnectivity: (store) => request.post('/RouteOne/TestConnectivity', store)
	expressions: {
		getAllSaturnExpressions: () => request.get(`/Settings/GetAllSaturnExpressions`),
		getBulkSaturnExpressions: (bulkRequest: any) => request.post(`/Settings/GetBulkSaturnExpressions`, bulkRequest),
		getSaturnExpressionByID: (expressionId: any) => request.post(`/Settings/GetSaturnExpressionByID`, new SaturnExpressionRequest({ id: expressionId })),
		getSaturnExpressionByName: (expressionName: any) => request.post(`/Settings/GetSaturnExpressionByName`, new SaturnExpressionRequest({ name: expressionName })),
		deleteExpression: (expressionId: any) => request.post(`/Settings/DeleteExpression/${expressionId}`),
		saveExpression: (expression: SaturnExpression) => request.post(`/Settings/SaveExpression`, expression),
	},
	getAllStateSettings: (): Promise<AxiosResponse<IStateSettings[]>> => request.get(`/Settings/State/GetAll`),
	getStateSettings: (stateCode: string): Promise<AxiosResponse<IStateSettings>> => request.get(`/Settings/State?stateCode=${stateCode}`),
	upsertStateSettings: (stateSettings: IStateSettings) => request.post(`/Settings/State/Upsert`, stateSettings),
	getPermissionSettings: (): Promise<AxiosResponse<PermissionSetting[]>> => request.get(`/Settings/GetPermissionSettings`),
	upsertPermissionSetting: (permissionSetting: PermissionSetting) => request.post(`/Settings/UpsertPermissionSetting`, permissionSetting),
	deletePermissionSetting: (id: string) => request.get(`/Settings/DeletePermissionSetting/${id}`),
	updateAllUsersWithXPosition: (positionCode: string, permissions: EmployeePermissionsType[]) => {
		return request.post<{ positionCode: string; permissions: EmployeePermissionsType[] }, SaturnResponse<boolean>>(`/Settings/SyncUsersWithPermissionSetting`, {
			positionCode,
			permissions,
		});
	},
};
